export default __webpack_public_path__ + "static/media/webs123b.5cf965ba.png";